import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CopyableText from "components/common/CopyableText";
import SubtleBadge from "components/common/SubtleBadge";
import useFormattedDate from "hooks/useFormatDate";
import React from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

export const ViewPurposeModal = ({
  selectedPurpose,
  loading,
  showModal,
  setShowModal,
}) => {
  const { formatDateTime } = useFormattedDate();
  return (
    <Modal
      show={showModal}
      onHide={() => setShowModal(false)}
      centered
      className="modal-small-text"
    >
      <Modal.Header className="py-3 fw-bold" style={{ fontSize: 14 }}>
        Donation Credit Purpose Details
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.8rem" }} className="pb-0">
        {loading ? (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ height: 120 }}
          >
            <Spinner animation="border" variant="success" />
          </div>
        ) : selectedPurpose ? (
          <>
            <p className="medium">
              <strong>ID:</strong> <CopyableText value={selectedPurpose.id} />
            </p>
            <p className="medium">
              <strong>Name:</strong> {selectedPurpose.name}
            </p>
            <p>
              <strong>Code:</strong> {selectedPurpose.code}
            </p>
            <div className="d-flex gap-2 mb-3">
              <strong>Status:</strong>{" "}
              {selectedPurpose.active ? (
                <SubtleBadge pill bg="success" className="d-block">
                  ACTIVE
                  <FontAwesomeIcon
                    icon="check"
                    transform="shrink-2"
                    className="ms-1"
                  />
                </SubtleBadge>
              ) : (
                <SubtleBadge pill bg="secondary" className="d-block">
                  DISABLED
                  <FontAwesomeIcon
                    icon="ban"
                    transform="shrink-2"
                    className="ms-1"
                  />
                </SubtleBadge>
              )}
            </div>
            <p>
              <strong>Description:</strong> {selectedPurpose.description}
            </p>
            <p>
              <strong>createdAt:</strong>{" "}
              {formatDateTime(selectedPurpose.createdAt)}
            </p>
            <p>
              <strong>UpdatedAt:</strong>{" "}
              {formatDateTime(selectedPurpose.updatedAt) || "NULL"}
            </p>
          </>
        ) : (
          <p>No data</p>
        )}
      </Modal.Body>
      <div className="p-3 d-flex justify-content-end">
        <Button
          size="sm"
          variant="secondary"
          onClick={() => setShowModal(false)}
        >
          Close
        </Button>
      </div>
    </Modal>
  );
};
